// extracted by mini-css-extract-plugin
module.exports = {"itemDescription":"OrderItem_itemDescription__248M1","bordered":"OrderItem_bordered__1OWCq","itemSubDescription":"OrderItem_itemSubDescription__2xXJB"};